/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OAuthJwtRefreshRequest } from '../models';
import type { OAuthJwtRefreshResponse } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class OAuthJwtRefreshControllerService {
    public static refresh(
        requestBody: OAuthJwtRefreshRequest,
        options?: ApiRequestOptions,
    ): Promise<ApiResponse<OAuthJwtRefreshResponse>> {
        return request('meet', {
            ...options,
            method: 'POST',
            url: '/api/v2/auth/refreshToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
